@if(filterItem) {
<button
  atxDropdown
  class="btn btn-block d-inline-flex align-items-center justify-content-between"
  [class]="dropdownButtonClass"
  [atxDropdownMenu]="menu"
  [atxDisabled]="disabled"
  [atxClickHide]="filterItem.isSingle ?? false"
  data-e2e="dropdown-menu-btn"
>
  <span class="mr-1 label-container" [ngClass]="labelTextClass">{{
    labelText
  }}</span>
  @if (activeValues.length && !filterItem.isSingle) {
  <atx-badge class="badge bg-primary text-white rounded-pill mr-1 ml-auto">{{
    activeValues.length
  }}</atx-badge>
  }
  <fa-icon [icon]="['fas', 'angle-down']" size="xs"></fa-icon>
</button>
<atx-dropdown-menu
  #menu="atxDropdownMenu"
  [extraClasses]="['promotion-dropdown']"
>
  @if (showAllVisible) {
  <atx-dropdown-item
    [attr.data-e2e]="'show-all-option'"
    [active]="activeValues.length === 0"
    (click)="
      activeValues.length === 0 ? $event.stopPropagation() : onToggle(null)
    "
  >
    {{ showAllLabel }}
  </atx-dropdown-item>
  } @if ((filterItem?.values ?? []).length > 0) { @for (option of
  filterItem?.values; track trackByValue($index, option)) {
  <atx-dropdown-item
    [attr.data-e2e]="'option-' + option.name"
    [active]="isSelectedByDefault() || isSelected(option.name)"
    (click)="onToggle(option.name)"
    class="justify-content-between"
  >
    <span [ngClass]="option.classNames">{{
      option.displayName ?? option.name
    }}</span>
    @if (option.count !== undefined && showCountBadge) {
    <atx-badge class="badge bg-primary text-white rounded-pill">{{
      option.count
    }}</atx-badge>
    }
  </atx-dropdown-item>
  } } @else {
  <atx-dropdown-item
    i18n="Ataraxia|Ataraxia Filter no available label@@ataraxiaNoAvailableLabel"
  >
    No available value for selection
  </atx-dropdown-item>
  }
</atx-dropdown-menu>
}
